const CACHE_KEY = "hola_client_ip";
const CACHE_TS_KEY = "hola_client_ip_ts";
const CACHE_TTL_MS = 30 * 60 * 1000; // 30 minutes
let memoryCache = null;
export class GetClientIp {
    constructor() {
        this.handle = async () => {
            // Check memory cache first
            if (memoryCache) {
                return memoryCache;
            }
            // Check sessionStorage cache
            try {
                const cached = sessionStorage.getItem(CACHE_KEY);
                const cachedTs = sessionStorage.getItem(CACHE_TS_KEY);
                if (cached && cachedTs) {
                    const age = Date.now() - Number(cachedTs);
                    if (age < CACHE_TTL_MS) {
                        const parsed = JSON.parse(cached);
                        memoryCache = parsed;
                        return parsed;
                    }
                }
            }
            catch (_a) {
                // sessionStorage unavailable or parse error — proceed to fetch
            }
            const apiUrl = process.env.REACT_APP_GATEWAY_HTTP;
            try {
                const response = await fetch(`${apiUrl}/badge/GetIp`, {
                    method: 'get'
                });
                const data = await response.json();
                // Store in memory and sessionStorage
                memoryCache = data;
                try {
                    sessionStorage.setItem(CACHE_KEY, JSON.stringify(data));
                    sessionStorage.setItem(CACHE_TS_KEY, String(Date.now()));
                }
                catch (_b) {
                    // sessionStorage full or unavailable
                }
                return data;
            }
            catch (error) {
                return console.error("An unknown error occurred");
            }
        };
    }
}
